import React from "react";
import { IonButton, IonIcon } from "@ionic/react";
import { bookmark, bookmarkOutline } from "ionicons/icons";
import {
  addBookmark,
  removeBookmark,
} from "../../redux/actions/currentProfileActions";
import { useSelector, useDispatch } from "react-redux";

function BookmarkBtn({ id }) {
  const { data } = useSelector((state) => state.currentProfile);
  const dispatch = useDispatch();

  const isBookmarked = data?.bookmarks?.some((bookmark) => bookmark._id === id);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    isBookmarked ? dispatch(removeBookmark(id)) : dispatch(addBookmark(id));
  };

  return (
    <IonButton
      fill="clear"
      size="small"
      shape="round"
      onClick={handleClick}
      className="sidebar-icon display-flex align-items-c post-btns__btn post-btns__reply no-padding-btn ion-no-padding"
    >
      <IonIcon
        icon={isBookmarked ? bookmark : bookmarkOutline}
        style={{
          color: isBookmarked ? "#d80621" : "inherit",
        }}
      />
    </IonButton>
  );
}

export default BookmarkBtn;

